import { Box, ButtonBase } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Components.Shared.Carousel;

type Props = {
  onScrollLeft: () => void;
  onScrollRight: () => void;
  canScrollLeft: boolean;
  canScrollRight: boolean;
};

export const CarouselNavigation = ({
  onScrollLeft,
  onScrollRight,
  canScrollLeft,
  canScrollRight,
}: Props) => {
  const { t } = useResource();

  return (
    <Box display="flex" gap={1}>
      <ButtonBase
        onClick={onScrollLeft}
        disabled={!canScrollLeft}
        aria-label={t(RESOURCES.ScrollLeft)}
        sx={({ palette }) => ({
          color: palette.primary.main,
          "&:disabled": { color: palette.action.disabled },
        })}
      >
        <ArrowBackIcon sx={{ fontSize: "1.75rem" }} />
      </ButtonBase>
      <ButtonBase
        onClick={onScrollRight}
        disabled={!canScrollRight}
        aria-label={t(RESOURCES.ScrollRight)}
        sx={({ palette }) => ({
          color: palette.primary.main,
          "&:disabled": { color: palette.action.disabled },
        })}
      >
        <ArrowForwardIcon sx={{ fontSize: "1.75rem" }} />
      </ButtonBase>
    </Box>
  );
};
